import React, { FC, useState, useEffect, useContext } from "react";
import { Form, Button, Table, Space, Row, Col } from "antd"
import type { ColumnsType } from 'antd/es/table';
import {
  statisticsOfSubject, exportStatisticsOfSubject,
  statisticsOfSubjectOnProvince, exportStatisticsOfSubjectOnProvince,
  statisticsOfSubjectOnCity, exportStatisticsOfSubjectOnCity,
  statisticsOfSubjectlOnSupport, exportStatisticsOfSubjectOnSupport,
  statisticsOfSubjectlOnRecipient, exportStatisticsOfSubjectlOnRecipient
} from '@root/common/service';
import { YearSelect, MonthSelect, SubjectSelect } from '@root/components/selectBox';
import { StatisticsContext, TotalViewProps } from '../index';

interface SubjectProps {
  averageWatchTime: number,
  courseCount: number,
  courseDuration: number,
  index: string,
  subjectId: number,
  subjectName: string,
  watchTime: number,
  watchUserCount: number
}

const Subject: FC = () => {
  const columns: ColumnsType<SubjectProps> = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index'
    },
    {
      title: '学科',
      dataIndex: 'subjectName',
      key: 'subjectName',
    },
    {
      title: '课程数量',
      dataIndex: 'courseCount',
      key: 'courseCount'
    },
    {
      title: '课程时长/h',
      dataIndex: 'courseDuration',
      key: 'courseDuration',
    },
    {
      title: '学习人数',
      dataIndex: 'watchUserCount',
      key: 'watchUserCount',
    },
    {
      title: '学习时长/h',
      dataIndex: 'watchTime',
      key: 'watchTime',
    },
    {
      title: '平均学习时长/h',
      dataIndex: 'averageWatchTime',
      key: 'averageWatchTime',
    }
  ];

  const [form] = Form.useForm();

  const context = useContext(StatisticsContext);

  const [total, setTotal] = useState<TotalViewProps | undefined>();
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [tableList, setTableList] = useState<SubjectProps[]>([]);
  const [tableTotal, setTableTotal] = useState<number>(0)

  const getStatisticsOfSubject = (page = 1) => {
    setTableLoading(true);
    const params = form.getFieldsValue();
    
    let getlist: any;
    switch (context.baseUserCategory) {
      case '10':
        getlist = statisticsOfSubject;
        break;

      case '11':
        getlist = statisticsOfSubjectOnProvince;
        break;

      case '15':
        getlist = statisticsOfSubjectOnCity;
        break;

      case '13':
        getlist = statisticsOfSubjectlOnSupport
        break;

      case '12':
        getlist = statisticsOfSubjectlOnRecipient
        break;
    }

    if (getlist) {
      getlist(
        { pageNum: page, pageSize: 10 },
        { ...params }
      ).then((res: any) => {
        const { data: { tableDataInfo, totalCourseSubjectView } } = res;
        setTableList(tableDataInfo.rows);
        setTableTotal(tableDataInfo.total);
        setTotal(totalCourseSubjectView);
      }).finally(() => {
        setTableLoading(false);
      });
    }
  }
  
  const onExport = () => {
    let params = form.getFieldsValue();
    let uri = '?';
    if (context && context.getUrlParams) {
      uri += context.getUrlParams(params)
    }

    // 根据角色判断导出所使用的接口
    let exportfun: any
    switch(context.baseUserCategory) {
      case '10':
        exportfun = exportStatisticsOfSubject;
        break;

      case '11':
        exportfun = exportStatisticsOfSubjectOnProvince;
        break;

      case '15':
        exportfun = exportStatisticsOfSubjectOnCity;
        break;

      case '13':
        exportfun = exportStatisticsOfSubjectOnSupport;
        break;
      case '12':
        exportfun = exportStatisticsOfSubjectlOnRecipient;
        break;        
    }

    if (exportfun) {
      exportfun(uri).then((res: any) => {
        if (context && context.excelDownload) {
          context.excelDownload(res);
        }
      })
    }
  }

  useEffect(() => {
    getStatisticsOfSubject()
  }, [])

  return (
    <div className="coursestatistics-country">
      <div className="coursestatistics-form-title">
        <Form
          form={form}
          name="customized_form_controls"
          layout="inline"
          onFinish={() => { getStatisticsOfSubject() }}
        >
          <Row>
            <Col span={6}>
              <YearSelect
                label="年度"
                name="year"
              />
            </Col>
            <Col span={6}>
              <MonthSelect
                label="月份"
                name="month"
              />
            </Col>
            <Col span={6}>
              <SubjectSelect 
                name="subjectId" 
                orgainizeSelect={ context.baseUserCategory === '13' || context.baseUserCategory === '12' }
              />
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <Space>
                <Button type="primary" htmlType="submit">
                  提交
                </Button>
                <Button onClick={() => {
                  form.resetFields();
                  getStatisticsOfSubject()
                }}>
                  重置
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="coursestatistics-export">
        <Button type="primary" onClick={onExport}>导出</Button>
      </div>
      <div className="coursestatistics-title">
        {total &&
          `合计: 课程数量：${total.courseCount}；课程时长/h：${total.courseDuration}；学习人数：${total.watchUserCount}；学习时长/h：${total.watchTime}；平均学习时长/h：${total.averageWatchTime}`
        }
      </div>
      <div className="coursestatistics-table">
        <Table
          rowKey="index"
          columns={columns}
          dataSource={tableList}
          loading={tableLoading}
          pagination={{
            total: tableTotal,
            onChange: (page) => { getStatisticsOfSubject(page) },
            showTotal: (total) => {
              return '共' + (total || 0) + '条记录';
            },
          }}
        />
      </div>
    </div>
  )
}

export default Subject;